import { SliceZone } from '@prismicio/react';
import React from 'react';

import SeoHead from '@/components/head/SeoHead';
import PageContainer from '@/components/layout/PageContainer';
import { usePageEntrance } from '@/hooks/usePageEntrance';
import { createClient } from '@/prismicio';
import type { AllDocumentTypes } from '@/prismicio-types';
import { components } from '@/slices';

const TOSPage = ({ page }: { page: AllDocumentTypes }) => {
  usePageEntrance();
  return (
    <PageContainer>
      <SeoHead
        title={'Terms of Service'}
        description={
          'Imagine your NFT as toys, GIFs, collectibles, and more. With OverpassIP, you can maximize the potential of your NFTs. Access opportunities to license them to Web2 brands, earn ongoing royalties, and join us in revolutionizing IP monetization.'
        }
      />
      <div className="enter-el rounded-[10px] bg-white pb-24 pt-12">
        <div className="mx-auto px-3 md:w-1/2">
          <SliceZone slices={page.data.slices} components={components} />
        </div>
      </div>
    </PageContainer>
  );
};

export async function getStaticProps({ previewData }: any) {
  const client = createClient({ previewData });
  const page = await client.getSingle('termsofservicepage');
  return {
    props: { page },
  };
}

export default TOSPage;
